export enum ResidencePermitGroup {
PermitWithAccessToJobMarket,
PermitRequiringApproval,
SeasonalWork,
}
